import {
	type QueryKey,
	type UseQueryOptions,
	useQuery,
} from "@tanstack/react-query";
import useVehicleHealthService from "../../services/vehicle-health";
import type { GetVehicleHealthReportRawResponse } from "../../services/vehicle-health/validation/GetVehicleHealthReport/index.types";

const useRawVehicleHealthReportByVin = <
	TQueryFnData = GetVehicleHealthReportRawResponse | undefined,
	TError = Error,
	TData = TQueryFnData,
	TQueryKey extends QueryKey = ("vehicle-health-report" | string | undefined)[],
>(
	vin?: string,
	options?: Omit<
		UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
		"queryKey" | "queryFn"
	>,
) => {
	const service = useVehicleHealthService();

	const query = useQuery<TQueryFnData, TError, TData, TQueryKey>({
		enabled: !!vin,
		queryKey: ["vehicle-health-report", vin] as unknown as TQueryKey,
		queryFn: async () => {
			if (!vin) return undefined as TQueryFnData;
			const { data } = await service.findVehicleHealthReport(vin);
			return data as TQueryFnData;
		},
		...options,
	});

	return {
		...query,
		isLoading: query.isLoading && query.fetchStatus !== "idle",
	};
};

export default useRawVehicleHealthReportByVin;
